import React from 'react';

const Instrucciones = (
    <div className="instrucciones__container">
      <h2>Instrucciones</h2><br />
      <p>El juego está diseñado para un solo jugador, por lo tanto se ha modificado el comportamiento de algunas funciones del juego original.</p><br /><p>En caso de caer en &quot;Pierde turno&quot;, decir una letra que no está en el panel, o fallar al resolverlo, se sumará una falta, cada vez que se cometan 3 faltas, la puntuación se dividirá por la mitad.</p>
    </div>
);

export default Instrucciones;
